import { useEffect, useRef } from "react"
import { PropTypes } from "prop-types"
import _ from "lodash"

function NonModalDialogDropdown(props) {
  const { ariaLabel, children, onEscape } = props
  const dialogRef = useRef(null)

  useEffect(() => {
    if (dialogRef) {
      dialogRef.current.focus()
    }
  }, [])

  useEffect(() => {
    const handleKey = e => {
      if (e.key === "Tab") {
        const [firstFocusable, lastFocusable] = getFocusableElements()

        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            e.preventDefault()
            lastFocusable.focus()
          }
        } else if (document.activeElement === lastFocusable) {
          e.preventDefault()
          firstFocusable.focus()
        }
      }

      if (e.key === "Escape") {
        onEscape(e)
      }
    }

    document.addEventListener("keydown", handleKey)

    return () => {
      document.removeEventListener("keydown", handleKey)
    }
  }, [onEscape])

  const getFocusableElements = () => {
    const isVisible = element =>
      window.getComputedStyle(element).getPropertyValue("display") !== "none"

    if (dialogRef) {
      const focusableElements = dialogRef.current.querySelectorAll(
        "button:not(:disabled), [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"
      )

      return [_.find(focusableElements, isVisible), _.findLast(focusableElements, isVisible)]
    }
  }

  return (
    <div
      className="oj-non-modal-dialog-dropdown"
      tabIndex={-1}
      aria-label={ariaLabel}
      role="dialog"
      ref={dialogRef}
    >
      {children}
    </div>
  )
}

NonModalDialogDropdown.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  onEscape: PropTypes.func.isRequired
}

export default NonModalDialogDropdown
